export default "__VITE_ASSET__44d3456f__"